import { connect } from 'react-redux'
import MyLessons from './my-lessons'
import {
  fetchMyPresentations,
  setPresentationToPublic
} from '../../../../../stores/my-presentations/my-presentations.actions'
import {
  getMyPresentationsList,
  getData,
  isPresentationUpdating,
  getPagination,
  fetchingPresentations,
  getFilters
} from '../../../../../stores/my-presentations/my-presentations.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const fetchingReq = fetchingPresentations(state)
  const fetching =
    fetchingReq.pending &&
    (fetchingReq.params.initiator === 'FIRST_LOAD' ||
      fetchingReq.params.initiator === 'PAGINATION' ||
      fetchingReq.params.initiator === 'FILTERS')
  return {
    fetched: !!getData(state),
    fetching,
    myPresentations: getMyPresentationsList(state),
    isUpdating: isPresentationUpdating(state),
    pagination: getPagination(state),
    filters: getFilters(state)
  }
}

const mapDispatchToProps = dispatch => ({
  setToPublic: (id, params) =>
    dispatch(setPresentationToPublic(id, params)).catch(errorHandler),
  fetchPresentations: params =>
    dispatch(fetchMyPresentations(params)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyLessons)
